/**
 * Thin wrapper around window.gtag that mirrors the @next/third-parties
 * sendGAEvent API so call-sites look consistent across both the Vite app
 * and the Next.js landing.
 *
 * gtag.js is loaded globally via index.html — this helper just provides
 * a typed, safe call surface.
 */
export function sendGAEvent(
  type: 'event',
  eventName: string,
  params?: Record<string, unknown>
): void {
  if (typeof window !== 'undefined' && typeof (window as any).gtag === 'function') {
    (window as any).gtag(type, eventName, params ?? {});
  }
}
